// clinicalStageSchema.js

import * as Yup from "yup";

export const clinicalStageSchema = Yup.object().shape({
    // disease_extent: Yup.string().required("Clinical extent of disease is required"),

    // disease_extent_other: Yup.string().when("disease_extent", {
    //     is: "Others",
    //     then: (schema) =>
    //         schema
    //             .required("Please specify other disease extent")
    //             .test(
    //                 "no-only-spaces",
    //                 "Specify field cannot be empty",
    //                 (value) => value && value.trim().length > 0
    //             ),
    //     otherwise: (schema) => schema.notRequired(),
    // }),

    // clinical_t: Yup.string().required("Clinical T (Tumor) is required"),
    // clinical_n: Yup.string().required("Clinical N (Nodes) is required"),
    // clinical_m: Yup.string().required("Clinical M (Metastasis) is required"),

    // pathological_t: Yup.string().required("Pathological T is required"),
    // pathological_n: Yup.string().required("Pathological N is required"),
    // pathological_m: Yup.string().required("Pathological M is required"),
});
